import { useCallback, useMemo, useState } from "react";

import api from "../../../../../utils/api";
import { EventosPg } from "../../../../../types";
import { useErrorSuccess } from "../../../../../hooks/useErrorSuccess";
import { T_Evento } from "../../../../../components/selects/celula";


export type ResponseEventBatismo = {
  listAll: EventosPg[] | []
  reset: VoidFunction
  nextPagina: VoidFunction
  getWithParams: (params: any) => void
  list: EventosPg[]
  searchPerEvent: (e: any) => void
  pesquisaPorMinisterio?: string
  pagina: number
  alterEvento: (field: keyof (T_Evento & { inicioForm: string | Date, fimForm: string | Date }), value: any) => void
  handleCreate: () => Promise<void>
  evento: T_Evento
}

const GetEventsBatismo = (): ResponseEventBatismo => {

  const { setMensagemSuccess, setMensagemError } = useErrorSuccess()

  const [listCheckinMembros, setListCheckinMembros] = useState<EventosPg[]>([]);
  const [resetar, setResetar] = useState<boolean>(false);
  const [list, setList] = useState<EventosPg[]>([]);
  const [pagina, setPagina] = useState<number>(0);

  const [dateFormat, setDateFormat] = useState<{ inicioForm: string | Date, fimForm: string | Date }>();
  const [evento, setEvento] = useState<T_Evento>({
    celula: 0,
    sede: '',
    inicio: '',
    fim: ''
  });

  const [pesquisaPorMinisterio, setPesquisaPorMinisterio] = useState<string>('');

  const searchPerEvent = (event: any) => setPesquisaPorMinisterio(event.target.value.replace(/script/g, ""));

  const nextPagina = useCallback(() => {
    setPagina((pagina) => pagina + 1)
  }, [pagina]);

  const alterEvento = (field: keyof (T_Evento & { inicioForm: string | Date, fimForm: string | Date }), value: any) => {
    if (field == 'inicioForm') {
      return setDateFormat((val) => ({ ...val, 'inicioForm': value }))
    }
    if (field == 'fimForm') {
      return setDateFormat((val) => ({ ...val, 'fimForm': value }))
    }
    setEvento((val) => ({ ...val, [field]: value }))
  }

  const handleCreate = async () => {

    try {

      const res = await api.post('evento/geral', evento);

      const req = res.data;

      setMensagemSuccess('Criado com sucesso');

      await getList();

    } catch (error) {

      setMensagemError(JSON.stringify(error?.response?.data, null, 2))

    }

  }

  const reset = useCallback(() => {
    setResetar(!resetar);
  }, [resetar])

  const getWithParams = (params: any) => {
    api.get<EventosPg[]>('evento/geral/grupo/1', { params: { ...params, idgrupo: 7 } })
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data);
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }


  const getList = useCallback(async () => {
    api.get<EventosPg[]>('evento/geral/grupo/1')
      .then(
        (sucesso) => {
          setListCheckinMembros(sucesso?.data?.sort((a,b) => b.id - a.id));
          setPagina(1);
        }
      )
      .catch(
        (error) => {
          console.log(error?.response);
        }
      )
  }, [resetar]);

  useMemo(() => {
    getList()
  }, [])


  return {
    listAll: listCheckinMembros,
    reset,
    nextPagina,
    evento: { ...evento, ...dateFormat },
    list,
    pagina,
    searchPerEvent,
    pesquisaPorMinisterio,
    getWithParams,
    alterEvento,
    handleCreate
  };
}

export default GetEventsBatismo;
